import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { appRoutes } from '@tekman/onmat/constants';
import { ProfileFacade } from '@tekman/onmat/store/profile';
import { map, take } from 'rxjs/operators';
import { merge } from 'rxjs';

export const profileGuard: CanActivateFn = () => {
  const router = inject(Router);
  const profileFacade = inject(ProfileFacade);

  return merge(
    profileFacade.profile$.pipe(
      take(1),
      map(() => true)
    ),
    // The redirect is a UrlTree and not an imperative navigate: the router runs every
    // canActivate in parallel and honours the first one in the array that does not
    // return true, so a school without licenses keeps landing on error/license
    // (LicensesGuard, declared before this guard) instead of this one cancelling that
    // navigation with error/group.
    profileFacade.error$.pipe(
      take(1),
      map(() => router.createUrlTree([`/${appRoutes.errorGroup}`]))
    )
  ).pipe(take(1));
};
